import { gql } from "lib/apolloClient";
import { userNameFragment } from "modules/CommonFragments";

export const similarityFragment = {
  similarityItem: gql`
    fragment similarityItem on SimilarityReport {
      status
      submissionId
      errorCode
      overallMatchPercentage
    }
  `,
};

export const attachmentFragment = {
  attachment: gql`
    fragment attachmentItem on Attachment {
      id
      name
      type
      mimeType
      url
      signedUrl
      thumbUrl
      title
      metadata
      streamUrl
      parentType
      isRead
      similarityReport {
        ...similarityItem
      }
      createdBy {
        ...userNameFields
      }
      lockingState {
        state
        scheduledAt
      }
      questionAttachment {
        ... on QuestionSubmission {
          id
          questionScore
          score {
            id
            value
          }
        }
        ... on Question {
          id
          questionScore
        }
      }
    }
    ${similarityFragment.similarityItem}
    ${userNameFragment}
  `,
  basicDetails: gql`
    fragment attachmentBasicDetailsItem on Attachment {
      id
      url
      signedUrl
      thumbUrl
      metadata
      name
      type
    }
  `,
};

export const projectTaskSubmissionItemResponseFragment = gql`
  fragment projectTaskSubmissionItemResponseItem on ProjectTaskSubmissionItemResponse {
    id
    attachments {
      ...attachmentItem
      createdAt
    }
    value
    submissionItem {
      id
      title
      fieldUID
    }
  }
  ${attachmentFragment.attachment}
`;

export const projectTaskResponseFragment = gql`
  fragment projectTaskResponseItem on ProjectTaskResponse {
    id
    task {
      id
      title
      description
      dueOn
      closesOn
      isStudentSubmissionEnabled
      isDeadlineAllDay
      submission {
        id
        type
      }
    }
    isComplete
    isSubmissionTurnedIn
    latestSubmissionResponse {
      id

      isLocked
      lockedAt

      isReturned
      returnedAt

      isTurnedIn
      turnedInAt

      status

      submission {
        id
        fieldUID
        items {
          id
          fieldUID
          title
        }
      }

      itemResponses {
        ...projectTaskSubmissionItemResponseItem
      }
    }
  }
  ${attachmentFragment.attachment}
  ${projectTaskSubmissionItemResponseFragment}
`;
